import { IAccDoiTuongKhongTinhHocPhi } from "./../../model/respone/category/IAccDoiTuongKhongTinhHocPhi";
import { apiClient } from "../apiClient";
export const DOI_TUONG_KHONG_TINH_HOC_PHI_ENDPOINT =
  "doi-tuong-khong-tinh-hoc-phi";
export const doiTuongKhongTinhHocPhiApi = {
  SelectAll: () => apiClient.get(`${DOI_TUONG_KHONG_TINH_HOC_PHI_ENDPOINT}`),
  Insert: (payload: IAccDoiTuongKhongTinhHocPhi) =>
    apiClient.post(`${DOI_TUONG_KHONG_TINH_HOC_PHI_ENDPOINT}`, payload),
  Update: (payload: IAccDoiTuongKhongTinhHocPhi) =>
    apiClient.put(`${DOI_TUONG_KHONG_TINH_HOC_PHI_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${DOI_TUONG_KHONG_TINH_HOC_PHI_ENDPOINT}/${id}`),
};
